import {
  APP_ID,
  AUTH_TOKEN,
  EHttpMethods,
  STORE_INFO,
  USER_ADDRESS_API,
} from "../constants";
import type { IAddressPayload } from "../types";
import { getCookie, setLocalSelectedAddressId } from "../utils";

interface IAddAndEditAddressResponse {
  id: string;
  [key: string]: string | object;
}

export const addAndEditAddress = async (
  onFailure: () => void,
  onSuccess: () => void,
  payload: IAddressPayload,
  storeId: string,
  editInfo?: { id: string },
): Promise<void> => {
  const authToken = getCookie(AUTH_TOKEN);
  const token = authToken ? `Bearer ${authToken}` : "";
  const storeInfo = getCookie(STORE_INFO);
  if (!storeInfo) {
    throw new Error("Store information is missing");
  }
  const [, langCode] = storeInfo.split("|");

  let url = USER_ADDRESS_API.replace("{{storeId}}", storeId).replace(
    "{{langCode}}",
    langCode,
  );

  if (editInfo) {
    url = url.concat(`/${editInfo.id}`);
    payload.id = editInfo.id;
  }

  try {
    const response = await fetch(url, {
      method: editInfo ? EHttpMethods.Put : EHttpMethods.Post,
      headers: {
        "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        storeId,
        token,
        appId: APP_ID,
      },
      body: new URLSearchParams(Object.entries(payload)).toString(),
    });

    if (response.ok) {
      const data = (await response.json()) as IAddAndEditAddressResponse;
      // Set the local selected address Id only when adding a new address.
      // In the edit flow, the address id remains unchanged
      if (!editInfo) {
        setLocalSelectedAddressId(data.id);
      }
      onSuccess();
    } else {
      onFailure();
    }
  } catch (error) {
    // eslint-disable-next-line no-console -- logger
    console.error("Error adding or editing address -", error);
    onFailure();
  }
};
